<div class="modal-header">
    <div class="modal-title">Update Users</div>

    <button id="update-user-btn" type="button" class="close" aria-label="Close" (click)="closeClick()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body" *ngIf="userDetails.ID">
    <form #updateUserForm="ngForm" novalidate="novalidate" autocomplete="off">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="label">Email</div>
                    <input type="text" class="input input__large input__blue" placeholder="e.g. supermail@mail.com"
                        [(ngModel)]="userDetails.EMAIL" #EMAIL="ngModel" name="EMAIL" disabled>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <div class="label">First Name</div>
                    <input type="text" class="input input__large input__blue" placeholder="First Name"
                        [(ngModel)]="userDetails.NAME_FIRST" #NAME_FIRST="ngModel" maxlength="20" name="NAME_FIRST"
                        required>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <div class="label">Last Name</div>
                    <input type="text" class="input input__large input__blue" placeholder="Last Name"
                        [(ngModel)]="userDetails.NAME_LAST" #NAME_LAST="ngModel" maxlength="20" name="NAME_LAST"
                        required>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="label">Role</div>
                    <app-custom-select [values]="roles" placeholder="Select Type" name="ORG_ROLE" id="ORG_ROLE"
                        [ngModel]="userDetails?.USER_ROLES?.length && userDetails?.USER_ROLES[0]?.ID"
                        (ngModelChange)="roleChange($event)"                        
                        #ORG_ROLE="ngModel" required>
                    </app-custom-select>
                    <!-- [(ngModel)]="userDetails.USER_ROLES[0].ID"  -->
                </div>
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <button id="update-user-cancel-btn" type="button" class="button secondary__button large__button"
        (click)="closeClick()">Cancel</button>
    <button id="update-add0users-btn" type="button" class="button primary__button large__button" (click)="submitClick()"
        [disabled]="!updateUserForm?.valid">Update Users</button>
</div>